import useCampaign from 'hooks/useCampaign';
import { RuleType } from 'schemas/IterationRule.schema.ts';
import { getRulesContentByType } from 'utils/contentUtils';

interface RulesExplanationTextProps {
    ruleType: RuleType
}

function RulesExplanationText({ ruleType }: RulesExplanationTextProps) {
  const { campaign } = useCampaign();

  const rulesContent = getRulesContentByType(ruleType, campaign.CampaignConfig?.Type);

  return <p>{rulesContent?.description}</p>;
}

export default RulesExplanationText;
